<template>
  <div>
    <div class="drawer-container"
         :class="{'drawer-container-active': isDrawerActive}"
         ref="drawerContainer"
         @click="hideDrawer"
         @touchstart="onTouchstart($event)"
         @touchmove="onTouchMove($event)"
         @touchend="onTouchEnd($event)">
      <div class="drawer-panel"
           :class="{'drawer-panel-active': isDrawerActive, 'drawer-panel-no-transition': noPanelTransition}"
           ref="drawerPanel"
           @click.stop=""
           @touchstart="onTouchstart($event)"
           @touchmove="onTouchMove($event)"
           @touchend="onTouchEnd($event)">
        <div class="drawer-header">
          <!--<img v-lazy="'../../static/img/logo.png'" class="logo">-->
        </div>
        <div class="drawer-content">
          <router-link to="/">
            <div class="drawer-link" @click="hideDrawer">
              <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                <path fill="#000000" d="M10,20V14H14V20H19V12H22L12,3L2,12H5V20H10Z" />
              </svg>
              <span>Home</span>
            </div>
          </router-link>

          <router-link to="/about">
            <div class="drawer-link" @click="hideDrawer">
              <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                <path fill="#000000" d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z" />
              </svg>
              <span>About Us</span>
            </div>
          </router-link>
          <!--<router-link to="/products">-->
            <!--<div class="drawer-link" @click="hideDrawer">-->
              <!--<svg style="width:24px;height:24px" viewBox="0 0 24 24">-->
                <!--<path fill="#000000" d="M10,21V18H3L8,13H5L10,8H7L12,3L17,8H14L19,13H16L21,18H14V21H10Z" />-->
              <!--</svg>-->
              <!--<span>Products</span>-->
            <!--</div>-->
          <!--</router-link>-->
          <!--<router-link to="/design">-->
            <!--<div class="drawer-link" @click="hideDrawer">-->
              <!--<svg style="width:24px;height:24px" viewBox="0 0 24 24">-->
                <!--<path fill="#000000" d="M21.41,11.58L12.41,2.58C12.05,2.22 11.55,2 11,2H4A2,2 0 0,0 2,4V11C2,11.55 2.22,12.05 2.59,12.42L11.59,21.42C11.95,21.78 12.45,22 13,22C13.55,22 14.05,21.78 14.41,21.41L21.41,14.41C21.78,14.05 22,13.55 22,13C22,12.45 21.77,11.94 21.41,11.58M5.5,7A1.5,1.5 0 0,1 4,5.5A1.5,1.5 0 0,1 5.5,4A1.5,1.5 0 0,1 7,5.5A1.5,1.5 0 0,1 5.5,7M17.27,15.27L13,19.54L8.73,15.27C8.28,14.81 8,14.19 8,13.5A2.5,2.5 0 0,1 10.5,11C11.19,11 11.82,11.28 12.27,11.74L13,12.46L13.73,11.73C14.18,11.28 14.81,11 15.5,11A2.5,2.5 0 0,1 18,13.5C18,14.19 17.72,14.82 17.27,15.27Z" />-->
              <!--</svg>-->
              <!--<span>Design</span>-->
            <!--</div>-->
          <!--</router-link>-->
          <router-link to="/contact">
            <div class="drawer-link" @click="hideDrawer">
              <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                <path fill="#000000" d="M16,18H7V4H16M11.5,22A1.5,1.5 0 0,1 10,20.5A1.5,1.5 0 0,1 11.5,19A1.5,1.5 0 0,1 13,20.5A1.5,1.5 0 0,1 11.5,22M15.5,1H7.5A2.5,2.5 0 0,0 5,3.5V20.5A2.5,2.5 0 0,0 7.5,23H15.5A2.5,2.5 0 0,0 18,20.5V3.5A2.5,2.5 0 0,0 15.5,1Z" />
              </svg>
              <span>Contact Us</span>
            </div>
          </router-link>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    data () {
      return {
        startX: 0,
        currentX: 0,
        touchingDrawer: false,
        noPanelTransition: false
      }
    },
    computed: mapState({
      isDrawerActive: 'isDrawerActive'
    }),
    methods: {
      hideDrawer () {
        this.$store.commit('hideDrawer')
      },
      onTouchstart (event) {
        this.touchingDrawer = true
        this.startX = event.touches[0].pageX
        this.currentX = this.startX
        this.noPanelTransition = true
        window.requestAnimationFrame(this.update)
      },
      onTouchMove (event) {
        if (!this.touchingDrawer) return
        this.currentX = event.touches[0].pageX
      },
      onTouchEnd (event) {
        if (!this.touchingDrawer) return
        this.touchingDrawer = false
        this.noPanelTransition = false
        const translateX = Math.min(0, this.currentX - this.startX)
        this.$refs.drawerPanel.style.transform = ''
        this.$refs.drawerContainer.style.backgroundColor = ``
        if (translateX < 0) {
          this.hideDrawer()
        }
      },
      update () {
        if (!this.touchingDrawer) return
        window.requestAnimationFrame(this.update)
        const translateX = Math.min(0, this.currentX - this.startX)
        this.$refs.drawerPanel.style.transform = `translateX(${translateX}px)`
        let panelWidth = Number(window.getComputedStyle(this.$refs.drawerPanel).getPropertyValue('width').slice(0, -2))
        let currentWidth = panelWidth + translateX
        let opacityRatio = currentWidth / panelWidth
        let opacityX = 0.6 * opacityRatio
        this.$refs.drawerContainer.style.backgroundColor = `rgba(0,0,0,${opacityX})`
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .drawer-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    pointer-events: none;
    will-change: background-color;
    background-color: rgba(0,0,0,0);
    transition: opacity .6s cubic-bezier(0,0,0.3,1);
    z-index: 3;
  }
  .drawer-container-active {
    background-color: rgba(0,0,0,0.6);
    pointer-events: auto;
  }
  .drawer-panel {
    position: absolute;
    top: 0;
    left: 0;
    width: 80%;
    max-width: 400px;
    height: 100%;
    background-color: #FFF;
    transform: translateX(-102%);
    box-shadow: 2px 0 12px rgba(0,0,0,0.4);
    transition: transform .3s cubic-bezier(0,0,0.3,1);
  }
  .drawer-panel-active {
    transform: none;
  }
  .drawer-panel-no-transition {
    transition: none;
  }
  .drawer-header {
    width: 100%;
    height: 120px;
    /*background-color: #f0fbfe;*/
  }
  .logo {
    width: 120px;
    height: auto;
    margin: auto;
    display: block;
  }
  .drawer-content {
    padding-top: 20px;
  }
  .drawer-link {
    margin-bottom: 15px;
    color: #000;
    display: block;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .drawer-link span {
    padding-left: 20px;
  }
</style>



// WEBPACK FOOTER //
// Drawer.vue?231cf935